/**
 * @generated SignedSource<<7f010cc180a1199786bade0369277c92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsPostMagazineArticle$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersCheckIsPostMagazineArticle";
};
export type helpersCheckIsPostMagazineArticle$key = {
  readonly " $data"?: helpersCheckIsPostMagazineArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPostMagazineArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsPostMagazineArticle"
};

(node as any).hash = "ae7234ed7ab54fd77e6112d151518fdd";

export default node;
